// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {hasAuthor, isAuthorized, roles, getUserName} from './security/index'
import App from './App'
import router from './router'
import store from './store'
import helper from './helper'
import vueToast from 'vue-toast-notification'
import {connect, checkConnect, sendMessageSocket, disConnectSocket, sendMessageSaveHistory, sendMessageSaveHistoryWithStartTime} from './websocket/index'

Vue.config.productionTip = false

const plugin = {
  install () {
    Vue.prototype.$disConnectSocket = disConnectSocket
    Vue.prototype.$checkConnectSocket = checkConnect
    Vue.prototype.$sendMessageSocket = sendMessageSocket
    Vue.prototype.$sendMessageSaveHistory = sendMessageSaveHistory
    Vue.prototype.$sendMessageSaveHistoryWithStartTime = sendMessageSaveHistoryWithStartTime
    Vue.prototype.$connectSocket = connect
    Vue.prototype.$helper = helper
    Vue.prototype.$hasAuthor = hasAuthor
    Vue.prototype.$isAuthorized = isAuthorized
    Vue.prototype.$authRoles = roles()
    Vue.prototype.$getUserName = getUserName
  }
}

Vue.use(vueToast, {
  position: 'top-right',
  duration: 2500,
  dismissible: true
})
Vue.use(plugin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js